<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData.js";
import {useCategoryStore} from "@/stores/Category";
import axios from "axios";

export default {
    name: "StrCategoryAutocomplete",
    props: {
        value: [Number, Array],
        readonly: Boolean,
        label: String,
        rules: Array,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const categoryStore = useCategoryStore();

        const category = ref(null);

        function findAll() {
            loading.value  = true;
            axios.get(`/categories`).then(response => {
                categoryStore.setCategoriesSelect(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        function input(value) {
            emit('input', value)
        }

        watch(() => props.value, () => {
            category.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            categoryStore,
            loading,
            inputColor,
            backgroundColor,
            category,
            input,
        }
    }
}
</script>

<template>
    <div>
        <v-autocomplete
            v-model="category"
            :items="categoryStore.categoriesSelect"
            item-value="id"
            item-text="fullName"
            outlined
            dense
            :label="label"
            :color="inputColor"
            :background-color="backgroundColor"
            :readonly="readonly"
            :loading="loading"
            :clearable="!readonly"
            @input="input"
            :rules="rules"
            hide-details="auto"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>

<style scoped>

</style>